import { Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { NoContentComponent } from './no-content';

export const ROUTES: Routes = [
    { path: '', component: WelcomeComponent },
    { path: 'welcome', component: WelcomeComponent },
    { path: 'mobile', loadChildren: "./mobile/mobile.module#MobileModule" },
    { path: 'configure', loadChildren: "./configure/configure.module#ConfigureModule" },
    { path: '**', component: NoContentComponent }
];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts